import { useState } from 'react'

interface AdditionalNotesSectionProps {
  initialValue?: string
  onChange: (value: string) => void
}

const AdditionalNotesSection = ({ initialValue = '', onChange }: AdditionalNotesSectionProps) => {
  const [additionalNotes, setAdditionalNotes] = useState(initialValue)

  const handleChange = (value: string) => {
    setAdditionalNotes(value)
    onChange(value)
  }

  return (
    <div className='flex flex-col gap-4'>
      <p className='!font-bold text-sm sm:text-base text-black leading-6'>
        Is there anything else you&apos;d like to add?
      </p>
      <div className='flex flex-col gap-2'>
        <label htmlFor='duplicate-notes' className='text-sm sm:text-base text-[#1f1f1f] leading-6'>
          Message:
        </label>

        <textarea
          id='additional-notes'
          rows={5}
          value={additionalNotes}
          onChange={({ target }) => handleChange(target.value)}
          placeholder="The more detail you provide, the more likely you'll hear from the perfect venue."
          className={`w-full bg-white border border-[#bfbfbf] rounded-[4px] px-[10px] py-2
        text-sm sm:text-base text-[#1f1f1f] leading-6 outline-none resize-none
        focus:border-[#595959] transition-colors`}
        />
      </div>
    </div>
  )
}

export default AdditionalNotesSection
